import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo, useEffect, useState } from 'react';
import classnames from 'classnames/bind';
import { DragAndDrop } from "./components/DragAndDrop";
import { FileInfo } from "./components/FileInfo";
import { Uploader } from "./components/Uploader";
import { checkFiles } from "./utils/checkFiles";
import { MessageText } from "../MessageText";
import { Label } from "../Label";
import styles from "./styles.pcss";
var cn = classnames.bind(styles);
export var FileUploader = /*#__PURE__*/memo(function (_ref) {
  var _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'FileUploader' : _ref$testName,
    _ref$maxFiles = _ref.maxFiles,
    maxFiles = _ref$maxFiles === void 0 ? 1 : _ref$maxFiles,
    _ref$maxFileSize = _ref.maxFileSize,
    maxFileSize = _ref$maxFileSize === void 0 ? 5000000 : _ref$maxFileSize,
    _ref$allowedTypes = _ref.allowedTypes,
    allowedTypes = _ref$allowedTypes === void 0 ? ['pdf', 'jpeg', 'png', 'rtf', 'doc', 'txt'] : _ref$allowedTypes,
    onChange = _ref.onChange,
    errorMessage = _ref.errorMessage,
    label = _ref.label,
    id = _ref.id,
    _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? false : _ref$multiple,
    _ref$isSuccessSending = _ref.isSuccessSending,
    isSuccessSending = _ref$isSuccessSending === void 0 ? false : _ref$isSuccessSending;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedFiles = _useState2[0],
    setSelectedFiles = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dragging = _useState4[0],
    setDragging = _useState4[1];
  var handleChange = function handleChange(event) {
    if (event.currentTarget.files) {
      prepareFiles(event.currentTarget.files);
    }
  };
  var prepareFiles = function prepareFiles(files) {
    var remainingLength = maxFiles - selectedFiles.length;
    var checkedFiles = checkFiles(files, remainingLength, allowedTypes, maxFileSize);
    var currentFiles = [].concat(_toConsumableArray(selectedFiles), _toConsumableArray(checkedFiles));
    if (onChange) {
      onChange(currentFiles.filter(function (file) {
        return file.file;
      }));
    }
    setSelectedFiles(currentFiles);
  };
  var onFileDelete = function onFileDelete(e) {
    var fileId = e.currentTarget.id;
    var newFiles = _toConsumableArray(selectedFiles);
    newFiles.splice(Number(fileId), 1);
    setSelectedFiles(newFiles);
    if (onChange) {
      onChange(_toConsumableArray(newFiles));
    }
  };
  // очищаем форму при успешной отправке
  useEffect(function () {
    if (isSuccessSending) {
      setSelectedFiles([]);
    }
  }, [isSuccessSending]);
  return /*#__PURE__*/React.createElement("div", {
    "data-component": testName,
    "data-t-id": "src-FileUploader"
  }, label && /*#__PURE__*/React.createElement(Label, {
    className: cn('label'),
    id: id,
    label: label
  }), /*#__PURE__*/React.createElement(DragAndDrop, {
    prepareFiles: prepareFiles,
    setDragging: setDragging
  }, /*#__PURE__*/React.createElement(Uploader, {
    allowedTypes: allowedTypes,
    dragging: dragging,
    errorMessage: errorMessage,
    handleChange: handleChange,
    id: id,
    maxFileSize: maxFileSize,
    multiple: multiple,
    "data-t-id": "src-FileUploader"
  })), errorMessage && /*#__PURE__*/React.createElement(MessageText, {
    errorMessage: errorMessage
  }), selectedFiles.map(function (file, i) {
    return /*#__PURE__*/React.createElement(FileInfo, {
      error: file.error,
      index: i,
      key: i,
      name: file.name,
      onFileDelete: onFileDelete,
      size: file.size
    });
  }));
});
FileUploader.displayName = FileUploader.name;